module.exports = __webpack_public_path__ + "static/img/Tela de NFe.2e9e8f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela de NFe.png
// module id = wdga
// module chunks = 0